import { render, staticRenderFns } from "./FallbackIcon.vue?vue&type=template&id=fe6778e0&"
import script from "./FallbackIcon.vue?vue&type=script&lang=js&"
export * from "./FallbackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports